import { FileDropzone, FormControl, FormField, FormInput, FormItem, FormLabel, FormMessage, Text } from "@sentricmusic/ui";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { extractFilenameToShow } from "@/features/gigs/utils/gigsClaimUtils";

import type { GigClaimFormValues } from "../utils/gigsClaimSchema";

type SpainProofSectionProps = {
  isUpdate: boolean;
  onFileChange: (file: File) => void;
};

function SpainProofSection({ isUpdate, onFileChange }: SpainProofSectionProps) {
  const { t } = useTranslation(["gigs"]);
  const { control, watch } = useFormContext<GigClaimFormValues>();
  const [proofFile, setProofFile] = useState<File | null>(null);
  const currentProofURL = watch("evidenceURL");
  const str = (s: string | null): string => s ?? "";

  return (
    <div>
      <Text as="subtitle">{t("gigs:es-proof-of-performance", "Please upload proof of performance")}</Text>
      <div className="flex flex-col gap-2">
        <FormField
          control={control}
          name="evidenceURL"
          render={({ field }) => (
            <FormItem>
              <FileDropzone
                label={str(t("gigs:add-evidence-text", "Add evidence of gig, such as a flyer. JPG, PNG or PDF accepted."))}
                file={proofFile}
                onFileAccepted={(file) => {
                  onFileChange(file);
                  setProofFile(file);
                }}
                onClick={() => {
                  setProofFile(null);
                  field.onChange(undefined);
                }}
                accept={{ "image/jpeg": [], "image/png": [], "application/pdf": [] }}
              />
              <FormMessage />
            </FormItem>
          )}
        />
        {isUpdate && currentProofURL != null && (
          <small className="font-semibold">
            {t("gigs:current-proof-of-performance", "Currently uploaded file:")}
            {" "}
            {extractFilenameToShow(currentProofURL)}
          </small>
        )}
        <FormField
          control={control}
          name="eventWebsiteURL"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("gigs:es-website-url", "Website URL")}</FormLabel>
              <FormControl>
                <FormInput
                  type="url"
                  placeholder={t("gigs:es-website-url", "Website URL") ?? "Website URL"}
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}

export default SpainProofSection;
